import React, { useEffect, useState}  from 'react'
import Card from '../../Common/Cards/Card'
import Skeleton from 'react-loading-skeleton';

function HomePage() {

  const [eventData, setEventData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // states to handle the skeleton
  const [loading, setLoading]= useState(true);

  useEffect(() => {
    // Fetch JSON data from your API endpoint
    fetch('https://hstonline.tech/hstsms/api/v1/programs/5ac460fa-1334-48a3-b45a-43a021271e1b')
      .then(response => response.json())
      .then(data => {
        console.log('Fetched data:', data);

        setEventData(Array(data.data));
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  console.log('eventData:', eventData);

  if (!Array.isArray(eventData)) {
    return <div>Loading...</div>;
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-gray-50 via-primary-50/30 to-secondary-50/20'>
      <div className="py-12 px-4">
        {/* Hero Section */}
        <div className="max-w-4xl mx-auto text-center mb-12 animate-slide-up">
          <h1 className='text-5xl font-bold bg-gradient-primary bg-clip-text text-transparent mb-4'>
            E-Voting Platform
          </h1>
          <p className='text-dark-600 text-lg max-w-2xl mx-auto'>
            Secure, transparent, and efficient digital voting for modern elections
          </p>
        </div>

        {/* Search Bar */}
        {loading ? (
          <div className="max-w-2xl mx-auto mb-12">
            <Skeleton count={1} height={56} duration={1} highlightColor='white' borderRadius={16}/>
          </div>
        ) : (
          <div className="max-w-2xl mx-auto mb-12 animate-scale-in">
            <div className="relative group">
              <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none">
                <i className="fa fa-search text-primary-500 text-lg"></i>
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full h-14 pl-14 pr-6 rounded-2xl shadow-medium hover:shadow-strong focus:shadow-glow transition-all duration-300 border-2 border-transparent focus:border-primary-300 focus:outline-none text-dark-700 placeholder-dark-400"
                placeholder='Search for events...'
              />
              <div className="absolute inset-0 rounded-2xl bg-gradient-primary opacity-0 group-hover:opacity-5 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          </div>
        )}

        {/* Events Grid */}
        {loading ? (
          <div className="max-w-7xl mx-auto">
            <Skeleton count={3} height={300} duration={1} highlightColor='white' borderRadius={16} className="mb-4"/>
          </div>
        ) : (
          <div className='flex flex-wrap justify-center max-w-7xl mx-auto page'>
            {eventData.map((event, index) => (
              <div key={event.id} style={{animationDelay: `${index * 0.1}s`}}>
                <Card data={event} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default HomePage